export const toolList = [
  {
    category: '業務支援',
    showDescription: true,
    tools: [
      {
        name: 'Terass Cloud',
        description:
          'TERASS Agentの活動に不可欠な、仲介業務を行うための基幹システム',
        url: 'https://agent-cloud.terass.com/s/?utm_source=terass-cloud&utm_medium=link-page&utm_campaign=2025_ver1',
        supportPageUrl:
          'https://www.notion.so/terass/Terass-Cloud-70fc31bbcf9d4345ac3b1c13021234b1',
        image: '/image/tools/terass-cloud.webp',
      },
      {
        name: 'Terass Picks',
        description: '物件検索の効率化とお客様への物件紹介を自動化',
        url: 'https://picks-agent.terass.com/search/mansion?utm_source=terass-cloud&utm_medium=link-page&utm_campaign=2025_ver1',
        supportPageUrl:
          'https://www.notion.so/terass/Terass-Picks-c29fd931d1c2462c9f8d5b1b740cc7af',
        image: '/image/tools/terass-picks.webp',
      },
      {
        name: 'Terass Loan Checker',
        description:
          '顧客の条件や物件に合わせて、最適な住宅ローンの検索・提案が可能',
        url: 'https://loan-checker.jp/login/terass-agent?utm_source=terass-cloud&utm_medium=link-page&utm_campaign=2025_ver1',
        supportPageUrl: '',
        image: '/image/tools/terass-loan-checker.webp',
      },
      {
        name: 'Estate Board',
        description:
          ' 収益不動産における未公開物件情報の送信と管理・顧客と買いニーズの管理ができる売買マッチングプラットフォーム',
        url: 'https://estate-board.com/?utm_source=terass-cloud&utm_medium=link-page&utm_campaign=2025_ver1',
        supportPageUrl:
          'https://www.notion.so/terass/EstateBoard-1d42fabcb4d0805a8d84fa24086d47d3?pvs=25',
        image: '/image/tools/estate-board.webp',
      },
      {
        name: 'Terass Portal',
        description:
          'PV数や問い合わせ状況を常に見える化し、売主様への媒介報告を自動化',
        url: 'https://portal.terass.com/agents?utm_source=terass-cloud&utm_medium=link-page&utm_campaign=2025_ver1',
        supportPageUrl:
          'https://www.notion.so/terass/Terass-Portal-9c3da7651b5e444c8dabbe617e22aad6',
        image: '/image/tools/terass-portal.webp',
      },
    ],
  },
  {
    category: '集客・商談支援',
    showDescription: true,
    tools: [
      {
        name: 'Terass Offer',
        description:
          '購入/売却顧客とエージェントを効率的にマッチングするプラットフォーム',
        url: 'https://offer.terass.com/agent/signin?utm_source=terass-cloud&utm_medium=link-page&utm_campaign=2025_ver1',
        supportPageUrl:
          'https://www.notion.so/terass/Terass-Offer-4337d44f077e4b78852fef1e4e4c85fe',
        image: '/image/tools/terass-offer.webp',
      },
      {
        name: 'auじぶん銀行',
        description:
          '好条件の優遇金利や団信付保に加え、TERASSのローンチームによる手厚いサポートもある住宅ローン',
        url: 'https://share.hsforms.com/10AxVryhQRR-VqeqrjZYA5Qr528s?utm_source=terass-cloud&utm_medium=link-page&utm_campaign=2025_ver1',
        supportPageUrl:
          'https://www.notion.so/terass/au-TERASS-f46384f31d55474cada1e5dfb748a112',
        image: '/image/tools/au-jibun-bank.webp',
      },
      {
        name: 'Terass Super Request',
        description:
          'TERASS本部が集客した商談案件を、条件に合ったエージェントに提供する仕組み',
        url: 'https://agent-cloud.terass.com/s/super-request/scoreboard?utm_source=terass-cloud&utm_medium=link-page&utm_campaign=2025_ver1',
        supportPageUrl:
          'https://www.notion.so/terass/Terass-Super-Request-1952fabcb4d080868468ebf6eccd2107?pvs=4',
        image: '/image/tools/terass-super-request.webp',
      },
    ],
  },
  {
    category: '売却・賃貸サポート',
    showDescription: true,
    tools: [
      {
        name: 'Terass Quick',
        description:
          '業界最高水準の買取額を提供する買取再販サービス。買取後の再販売も担当可能',
        url: 'https://www.notion.so/terass/Terass-Quick-12a0d7fd56584840b4db4b8155aaf4a5',
        supportPageUrl: '',
        image: '/image/tools/terass-quick.webp',
      },
      {
        name: 'Terass Partners',
        description:
          '毎月の管理料売上が得られる賃貸管理に関する各種サービスの確認・相談窓口',
        url: 'https://www.notion.so/terass/TERASS-AI-53e673cac4d74493aa109b9418699b39',
        supportPageUrl:
          'https://www.notion.so/terass/TERASS-AI-53e673cac4d74493aa109b9418699b39#9d710af3a2954be38c3923a5ff290912',
        image: '/image/tools/terass-partners.webp',
      },
    ],
  },
  {
    category: 'エージェント成長支援',
    showDescription: true,
    tools: [
      {
        name: 'Agent Academy',
        description:
          'Expert Agent以上を目指すエージェントを対象とした圧倒的成長プログラム',
        url: 'https://www.notion.so/terass/Agent-Academy-AA-92bc7acbee414d35b6ae52a0ba62dd46#dc146fa220c74f59af42f87e4d9e944f',
        supportPageUrl: '',
        image: '/image/tools/agent-academy.webp',
      },
    ],
  },
  {
    category: 'その他のツール',
    showDescription: false,
    tools: [
      {
        name: 'Google Calendar',
        url: 'https://calendar.google.com/calendar/u/0/r/week',
        supportPageUrl: '',
        image: '/image/tools/google-calendar.webp',
      },
      {
        name: 'Google Meet',
        url: 'https://meet.google.com/landing',
        supportPageUrl: '',
        image: '/image/tools/google-meet.webp',
      },
      {
        name: 'Google Drive',
        url: 'https://drive.google.com/drive/home',
        supportPageUrl: '',
        image: '/image/tools/google-drive.webp',
      },
      {
        name: 'Notion',
        url: 'https://www.notion.so/terass/Notion-Terass-Agent-Information-7ba9c82ed6d248e89aa625e9c93f9321',
        supportPageUrl: '',
        image: '/image/tools/notion.webp',
      },
    ],
  },
]

export interface Tool {
  name: string
  description?: string
  url: string
  supportPageUrl?: string
  image: string
}

export interface ToolCategory {
  category: string
  showDescription: boolean
  tools: Tool[]
}
